/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  /**
   * This mutation set the canvas in the internal state
   * @param state
   * @param canvas
   */
  [types.SET_CANVAS](state, canvas) {
    state.canvas = canvas;
  },
  /**
   * This function reset the internal steps data
   */
  [types.RESET](state) {
    state.steps = [];
    state.currentStep = -1;
  },
  /**
   * This function clear all the internal state data
   */
  [types.CLEAR](state) {
    if (state.canvas) {
      state.canvas.dispose();
    }
    state.canvas = null;
    state.steps = null;
    state.currentStep = null;
    state.isPopArtOrTileApplied = false;
  },
  /**
   * This function stores the canvas current state into the steps array and increase the current step
   * @param stepJson
   */
  [types.PUSH_STEP](state, stepJson) {
    if (Array.isArray(state.steps)) {
      state.steps.push(stepJson);
    } else {
      throw new Error(
        "Unable to push step, steps haven't been initialized yet"
      );
    }
  },
  /**
   * This mutation increase the current step
   */
  [types.INCREASE_STEP](state) {
    state.currentStep = state.currentStep + 1;
  },
  /**
   * This mutation decrease the current step
   */
  [types.DECREASE_STEP](state) {
    state.currentStep = state.currentStep - 1;
  },
  /**
   * This mutation save the current position view in ugc flow
   */
  [types.SET_CURRENT_UGC_VIEW](state, payload) {
    state.currentUgcView = payload;
  },
  /**
   * This mutation increment the currentUgcView index
   */
  [types.NEXT_CURRENT_UGC_VIEW](state) {
    state.currentUgcView += 1;
  },
  /**
   * This mutation save a boolean variable to know if the user skip
   * from almost done to confirn design
   */
  [types.SET_SKIP_ALMOST_DONE](state, payload) {
    state.skipAlmostDone = payload;
  },
  /**
   * This mutation set a global state loading useful to disable/enable action buttons
   */
  [types.SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [types.SET_ACTIVE_CONTROL](state, control) {
    state.activeControl = control;
  },
  /**
   * This mutation sets the boolean value passed in the payload in the prop,
   * this prop is used to know if the user already applied a popart or tile filter.
   */
  [types.APPLY_TILE_OR_POPART](state, apply) {
    state.isPopArtOrTileApplied = apply;
  },
  /**
   * Restore the state manager from goBack with the last placement configuration.
   */
  [types.SET_STATE_MANAGER](state, payload) {
    state.currentStep = payload.currentStep;
    state.steps = payload.steps;
    state.isPopArtOrTileApplied = payload.isPopArtOrTileApplied;
  },
  /**
   * Restart the state manager to prepare initialize new ugc flow.
   */
  [types.RESTART_STATE_MANAGER](state) {
    state.currentUgcView = 0;
    state.skipAlmostDone = false;
  }
};

export default mutations;
